module.exports = __webpack_public_path__ + "static/media/quote.1d660154.png";